import React, { useEffect } from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListQuanLyThuChiNgoaiLe,
  updateDataSearch,
} from "../../../actions/QuanLyThuChiNgoaiLe";
import { formatNumber } from "utils/currencyFormat";
import { BtnThemMoiChiNgoaiLe } from "./ThemMoi/ThemMoiChiNgoaiLe/BtnThemMoiChiNgoaiLe";
import { BtnThemMoiThuNgoaiLe } from "./ThemMoi/ThemMoiThuNgoaiLe/BtnThemMoiThuNgoaiLe";
import { formatCurrency2 } from "utils/currencyFormat";
export const TableDanhSach = ({
  themThu,
  themChi,
  inPhieuThu,
  inPhieuChi,
  suaPhieu,
  xoaPhieu,
}) => {
  const dispatch = useDispatch();
  const listQuanLyThuChiNgoaiLeFull = useSelector(
    (state) => state.listQuanLyThuChiNgoaiLeFull
  );
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe
  );
  useEffect(() => {
    dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListQuanLyThuChiNgoaiLe(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    dispatch(updateDataSearch(data));
    dispatch(getListQuanLyThuChiNgoaiLe(data));
    loadTaiSan();
  };
  const TotalQuantity = listQuanLyThuChiNgoaiLeFull.TotalQuantity;

  return (
    <>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (listQuanLyThuChiNgoaiLeFull.getListQuanLyThuChiNgoaiLeLoading
                    ? "is-active"
                    : "")
                }
              ></div>
            </div>
            <div className=" hidden-mobile-main show-table-main mb-1">
              <div className="iconbutton-new  show-table-main">
                <div className="row">
                  <div className="col-sm-12 col-md-9">
                    <span>{themThu && <BtnThemMoiThuNgoaiLe />}</span>
                    <span style={{ marginLeft: "10px" }}>
                      {themChi && <BtnThemMoiChiNgoaiLe />}
                    </span>
                  </div>
                  <div className="col-sm-12 col-md-3 d-flex just-end"></div>
                </div>
              </div>
            </div>
            <div className="table-mobile  table-mobile-hover table-responsive-new ">
              <div className="custom-table-wrapper">
                <div
                  className="table-headers-v2  hidden-mobile-main"
                  style={{
                    backgroundColor: "#F5F8FE",
                    top: "60px",
                  }}
                >
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />
                      <span className="color-do-bold">
                        [ {listQuanLyThuChiNgoaiLeFull.TotalQuantity} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-11-sm center-flex ">
                    <p className="center">Ngày</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-sm  center-flex ">
                    <p className="center">Mã phiếu</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-sm">
                    <p className="text-left">Nhân viên</p>
                  </div>
                  <div className="custom-table-header flex-basis-16 flex-basis-16-sm">
                    <p className="text-left">Người nhận/ Người nộp tiền</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-11-sm">
                    <p className="text-center">Loại phiếu</p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-11-sm">
                    <p className="text-right">
                      Thu ngoài lề
                      <br />
                      <span
                        className="color-do-bold word-break"
                        title={formatNumber(
                          listQuanLyThuChiNgoaiLeFull.TotalTienThu
                        )}
                      >
                        {formatCurrency2(
                          listQuanLyThuChiNgoaiLeFull.TotalTienThu
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-11-sm">
                    <p className="text-right">
                      Chi ngoài lề
                      <br />
                      <span
                        className="color-do-bold word-break"
                        title={formatNumber(
                          listQuanLyThuChiNgoaiLeFull.TotalTienChi
                        )}
                      >
                        {formatCurrency2(
                          listQuanLyThuChiNgoaiLeFull.TotalTienChi
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-11-sm  action-cell">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>
                <div className="custom-table-body">
                  <ContentTable
                    listQuanLyThuChiNgoaiLe={listQuanLyThuChiNgoaiLeFull.List}
                    inPhieuThu={inPhieuThu}
                    inPhieuChi={inPhieuChi}
                    suaPhieu={suaPhieu}
                    xoaPhieu={xoaPhieu}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.pageIndex}
            pageSize={dataSearch.pageSize}
            totalCount={TotalQuantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
